import {
  GET_TEXTOS,
  GET_TEXTOS_FAIL,
  GET_TEXTOS_SUCCESS,
} from "../ActionTypes";


const textosAutoCheckin = (state, { payload, type }) => {
  switch (type) {
    case GET_TEXTOS:
      return {
        ...state,
        textosAutoCheckin: {
          ...state.textosAutoCheckin,
          loading: true,
          error: false,
          data: false,
        },
      };
    case GET_TEXTOS_SUCCESS:
      return {
        ...state,
        textosAutoCheckin: {
          ...state.textosAutoCheckin,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case GET_TEXTOS_FAIL:
      return {
        ...state,
        textosAutoCheckin: {
          ...state.textosAutoCheckin,
          loading: false,
          error: payload,
          data: false,
        },
      };


    default:
      return state;
  }
};

export default textosAutoCheckin;
